import { getCDNUrl } from './CDNUrl';

const snsLogoCDN = (fileName) => getCDNUrl('logo', fileName);

export const INSTAGRAM_LOGO = snsLogoCDN('Instagram.png');
export const FACEBOOK_LOGO = snsLogoCDN('Facebook.png');
export const NAVER_LOGO = snsLogoCDN('Naver.png');
export const NAVER_BAND_LOGO = snsLogoCDN('NaverBand.png');
export const KAKAO_TALK_LOGO = snsLogoCDN('KaKaoTalk.png');
export const KAKAO_STORY_LOGO = snsLogoCDN('KaKaoStory.png');
export const TWITTER_LOGO = snsLogoCDN('Twitter.png');
